<span class="material-symbols-rounded" style="font-size: 56px;color: var(--danger)">delete</span>
<div class="title-large" data-testid="title" style="margin-top: 16px;margin-bottom: 24px;">Delete site information?
</div>
<div class="body-large" data-testid="body" style="margin-bottom: 8px">Are you sure you want to delete information for
</div>
<div class="title-small" data-testid="siteName" style="margin-bottom: 32px">{{ siteMessage.siteName }}</div>
<div style="display: flex;gap:8px;width: 100%">

  <button (click)="dialogRef.close()" class="secondary-button" data-testid="cancelButton" style="flex: 1">Cancel
  </button>
  <button (click)="deleteClicked()" class="danger-button" data-testid="deleteButton" style="flex: 1">Delete</button>
</div>
